import { render } from "./EditAktivitet.vue?vue&type=template&id=1f13022c"
import script from "./EditAktivitet.vue?vue&type=script&lang=js"
export * from "./EditAktivitet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__